import { CanMatchFn } from '@angular/router';
import { AppHandshakeService } from '../services/app-handshake.service';
import { inject } from '@angular/core';

export const handshakeGuardGuard: CanMatchFn = (route, segments) => {
  const svc = inject(AppHandshakeService);

  return svc.ensureHandshake();
};
